/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PreconfiguredSkillReference = {
  type: "preconfigured";
  /**
   * Name of a preconfigured skill (e.g., 'pdf', 'docx', 'xlsx', 'pptx').
   */
  name: string;
};

/** @internal */
export const PreconfiguredSkillReference$inboundSchema: z.ZodType<
  PreconfiguredSkillReference,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("preconfigured"),
  name: z.string(),
});
/** @internal */
export type PreconfiguredSkillReference$Outbound = {
  type: "preconfigured";
  name: string;
};

/** @internal */
export const PreconfiguredSkillReference$outboundSchema: z.ZodType<
  PreconfiguredSkillReference$Outbound,
  z.ZodTypeDef,
  PreconfiguredSkillReference
> = z.object({
  type: z.literal("preconfigured"),
  name: z.string(),
});

export function preconfiguredSkillReferenceToJSON(
  preconfiguredSkillReference: PreconfiguredSkillReference,
): string {
  return JSON.stringify(
    PreconfiguredSkillReference$outboundSchema.parse(
      preconfiguredSkillReference,
    ),
  );
}
export function preconfiguredSkillReferenceFromJSON(
  jsonString: string,
): SafeParseResult<PreconfiguredSkillReference, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PreconfiguredSkillReference$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PreconfiguredSkillReference' from JSON`,
  );
}
